import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Options.css";
import BlockedSellersOption from "./BlockedSellers/BlockedSellers";
import BlockedWordsOption from "./BlockedWords/BlockedWords";
import FavoriteItemsOption from "./FavoriteItems/FavoriteItems";

const Options: React.FC = () => {
  const [activeTab, setActiveTab] = useState("BlockedWords");
  const navigate = useNavigate();

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  const handleBackToDashboard = () => {
    navigate("/dashboard");
  };

  return (
    <div className="options-container">
      {/* Back Button */}
      <button className="back-button" onClick={handleBackToDashboard}>
        ← Back to Dashboard
      </button>

      {/* Title */}
      <h1 className="options-title">Options</h1>

      {/* Tabs */}
      <div className="tabs">
        <button
          className={activeTab === "BlockedWords" ? "active-tab" : ""}
          onClick={() => handleTabChange("BlockedWords")}
        >
          Blocked Words
        </button>
        <button
          className={activeTab === "BlockedSellers" ? "active-tab" : ""}
          onClick={() => handleTabChange("BlockedSellers")}
        >
          Blocked Sellers
        </button>
        <button
          className={activeTab === "FavoriteItem" ? "active-tab" : ""}
          onClick={() => handleTabChange("FavoriteItem")}
        >
          Favorite Items
        </button>
      </div>

      {/* Content for Active Tab */}
      <div className="tab-content">
        {activeTab === "BlockedWords" && <BlockedWordsOption />}
        {activeTab === 'BlockedSellers' && <BlockedSellersOption />}
        {activeTab === 'FavoriteItem' && <FavoriteItemsOption />}
      </div>
    </div>
  );
};

export default Options;
